module.exports = __webpack_public_path__ + "static/media/eyeslash.a6a4494e.svg";